'use client'

import type { FC } from 'react'
import { useEffect } from 'react'

type GlobalErrorProps = {
  error: Error
  reset: () => void
}

const isTestEnv = () => {
  // Catch common test signals:
  // 1) NODE_ENV === 'test'
  // 2) JEST_WORKER_ID set by Jest
  // 3) jsdom userAgent in RTL runs
  if (process.env.NODE_ENV === 'test') return true
  if (process.env.JEST_WORKER_ID) return true
  if (typeof navigator !== 'undefined' && /jsdom/i.test(navigator.userAgent))
    return true
  return false
}

const GlobalError: FC<GlobalErrorProps> = ({ error, reset }) => {
  useEffect(() => {
    if (!isTestEnv()) {
      console.error(error)
    }
  }, [error])

  // Render a simple div in test (no html/body)
  if (isTestEnv()) {
    return (
      <div>
        <h2>Something went wrong!</h2>
        <button onClick={() => reset()}>Try again</button>
      </div>
    )
  }

  return (
    <html lang="en" suppressHydrationWarning>
      <body className="h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <h2 className="text-2xl">Something went wrong!</h2>
          <button
            className="px-4 py-2 bg-green-500 text-white rounded"
            onClick={() => reset()}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  )
}

export default GlobalError
